const SET_CLIENT_NOTIFICATION = 'SET_CLIENT_NOTIFICATION' as const;
const CLEAR_CLIENT_NOTIFICATION = 'CLEAR_CLIENT_NOTIFICATION' as const;

// Action

type ClientNotificationMessage = {
  title: string;
  message: string;
};

function setClientNotification(notification: ClientNotificationMessage) {
  return {
    type: SET_CLIENT_NOTIFICATION,
    payload: notification,
  };
}

function clearClientNotification() {
  return {
    type: CLEAR_CLIENT_NOTIFICATION,
  };
}

export const ClientNotificationActionCreators = {
  setClientNotification,
  clearClientNotification,
};

type SetClientNotificationAction = ReturnType<typeof setClientNotification>;
type ClearClientNotificationAction = ReturnType<typeof clearClientNotification>;

type ClientNotificationAction =
  | SetClientNotificationAction
  | ClearClientNotificationAction;

type ClientNotificationState = {
  clientNotification:
    | {
        isOpen: false;
      }
    | {
        isOpen: true;
        title: string;
        message: string;
      };
};

const initialState: ClientNotificationState = {
  clientNotification: {
    isOpen: false,
  },
};

// Selector

export function clientNotificationSelector(rootState: {
  clientNotification: ClientNotificationState;
}) {
  return rootState.clientNotification;
}

// Reducer

export function clientNotificationReducer(
  state = initialState,
  action: ClientNotificationAction
): ClientNotificationState {
  switch (action.type) {
    case SET_CLIENT_NOTIFICATION:
      return {
        ...state,
        clientNotification: {
          isOpen: true,
          title: action.payload.title,
          message: action.payload.message,
        },
      };
    case CLEAR_CLIENT_NOTIFICATION:
      return {
        ...state,
        clientNotification: {
          isOpen: false,
        },
      };
    default:
      return state;
  }
}
